import { queryClient } from 'v2/configs/rq-setup'
import { getSettingsQueryKeys } from 'v2/shared/utils/query-key-management'
import type { SonnerConfig } from 'v2/shared/utils/sonner-manager'

export const offlineToastConfig: SonnerConfig = {
  id: 'offline',
  title: 'Internet connection lost',
  description: 'You are offline, please check your internet connection.',
  showDoNotShowAgain: false,
}

export const microphoneToastConfig = {
  id: 'microphone',
  title: 'Microphone access required',
  description: 'Enable microphone access from the browser to allow call functionality',
}

export const pubnubToastConfig: SonnerConfig = {
  id: 'pubnub',
  title: 'Connection lost',
  type: 'error',
  description: 'Oops, we seem to have lost connection to the server, please reconnect',
  showDoNotShowAgain: false,
  action: {
    onClick: () =>
      queryClient.invalidateQueries({ queryKey: getSettingsQueryKeys().pubnubTokenBase }),
    label: 'Reconnect',
  },
}

export const activeCallToastConfig: SonnerConfig = {
  id: 'active-call',
  type: 'info',
  title: 'Ongoing Call',
  description: 'To take any actions for the ongoing call, please switch to the active call tab.',
  showDoNotShowAgain: false,
}

export const phoneToastConfig: SonnerConfig = {
  id: 'phone',
  title: 'Phone disconnected',
  type: 'error',
  description: 'Please reload the page to reconnect',
  action: {
    onClick: async () => window.location.reload(),
    label: 'Reload',
  },
}

export const idleStatusUpdateToastConfig: (
  onClick: () => Promise<void>,
  statusName: string,
) => SonnerConfig = (onClick, statusName) => ({
  id: 'idle-status-update',
  title: `Marked ${statusName} due to inactivity`,
  description: 'Your conversations will be paused until your status is set to available.',
  showDoNotShowAgain: false,
  action: {
    onClick,
    label: 'Go online',
  },
})
